module.exports = __webpack_public_path__ + "img/person1.d879526c.png";